<bw-action-card-legacy
  (ctaClicked)="routeToSavings()"
  [cardConfig]="savingsInitialCard"
></bw-action-card-legacy>
